/**
 * Function to read all elements from cart local storage
 * @returns {array}
 */
export function getCartItems() {

  if (typeof window === 'undefined') {
    return [];
  }

  const cartItems = window.localStorage.getItem('CBX_Cart_Items');
  try {
    const cartElements = JSON.parse(cartItems);
    if (Array.isArray(cartElements)) {
      return cartElements;
    }
    throw new Error('NotArrayException');
  } catch (e) {
    window.localStorage.removeItem('CBX_Cart_Items');
    return [];
  }
}

/**
 * Function to store contact information to local storage
 * @param {Object} contactInformation Element to add to cart
 * @returns {array}
 */
export function getContactInformation() {
  const contactInfo = window.localStorage.getItem('CBX_Contact_Information');
  try {
    const contact = JSON.parse(contactInfo);
    return contact || {};
  } catch (e) {
    window.localStorage.removeItem('CBX_Cart_Items');
    return {};
  }
}

/**
 * Function to read all elements from cart local storage
 * @param {Object} item Element to add to cart
 * @returns {array}
 */
export function saveQuickData(quickData) {
  window.localStorage.setItem('CBX_Quick_Data', JSON.stringify(quickData));
  return quickData;
}

/**
 * Function to read all elements from cart local storage
 * @param {Object} item Element to add to cart
 * @returns {array}
 */
export function getQuickData() {
  const data = window.localStorage.getItem('CBX_Quick_Data');
  const quickData = JSON.parse(data);
  return quickData;
}

export function removeQuickData() {
  const data = window.localStorage.getItem('CBX_Quick_Data');
  if(window.localStorage.getItem('currentFlow') !== 'Bundles') window.localStorage.removeItem('currentFlow');
  window.localStorage.removeItem('assisted_data');
  window.localStorage.removeItem('CBX_Quick_Data');
  window.localStorage.removeItem('shuttle_data');
  window.localStorage.removeItem('shuttle_seats');
  window.localStorage.removeItem('shuttle_data_round');
  window.localStorage.removeItem('shuttle_seats_round');
  window.localStorage.removeItem('CBX_Shuttle_Routes');
  window.localStorage.removeItem('CBX_Shuttle_Return_Routes');
}

/**
 * Function to read all elements from cart local storage
 * @param {Object} item Element to add to cart
 * @returns {array}
 */
export function insertCartItem(item) {
  const cartItems = getCartItems();
  cartItems.push(item);
  window.localStorage.setItem('CBX_Cart_Items', JSON.stringify(cartItems));
  return item;
}

/**
 * Function to delete element from cart local storage
 * @param {Number} item Element index to delete from cart
 * @returns {array}
 */
export function deleteCartItem(index) {
  const cartItems = getCartItems();
  cartItems.splice(index, 1);
  window.localStorage.setItem('CBX_Cart_Items', JSON.stringify(cartItems));
}

/**
 * Function to store contact information to local storage
 * @param {Object} contactInformation Element to add to cart
 * @returns {array}
 */
export function insertContactInfo(contactInformation) {
  window.localStorage.setItem('CBX_Contact_Information', JSON.stringify(contactInformation));
  return contactInformation;
}


export function saveTripShutleData(data) {
  window.localStorage.setItem('shuttle_data', JSON.stringify(data));
  return data;
};

export function saveTripShuttleRoundData(data) {
  window.localStorage.setItem('shuttle_data_round', JSON.stringify(data));
  return data;
};

/**
 * Function to store shuttle passenger information to local storage
 * @param {Object} shuttleInformation Element to add to cart
 * @returns {array}
 */
export function insertShuttleInfo(shuttleInformation) {
  window.localStorage.setItem('CBX_Shuttle_Information', JSON.stringify(shuttleInformation));
}

export function clearData(){
    window.localStorage.removeItem('CBX_Contact_Information');
    window.localStorage.removeItem('CBX_Cart_Items');
    window.localStorage.removeItem('parking');
    window.localStorage.removeItem('CBX_Parking_Status');
    window.localStorage.removeItem('parkingTicketsSummary');
    window.localStorage.removeItem('CBX_Step_Ticket');
    window.localStorage.removeItem('CBX_Step_Parking');
    window.localStorage.removeItem('shuttle_data');
    window.localStorage.removeItem('shuttle');

}

export function setParkingStatus(parkingStatus) {
  window.localStorage.setItem('CBX_Parking_Status', parkingStatus.toString(10));
}

export function getParkingStatus() {
  if (typeof window === 'undefined') {
    return 0;
  }
  const statusParking = window.localStorage.getItem('CBX_Parking_Status');
  return statusParking ? parseInt(statusParking, 10) : 0;
}

export function setCleanShuttleRoutes(shuttleStatus) {
  return ;
}

export function getCleanShuttleRoutes() {
  return 0;
}

export function setCurrentStepTicket(stepTicket) {
  window.localStorage.setItem('CBX_Step_Ticket', stepTicket.toString(10));
}

export function getCurrentStepTicket() {
  const currentStep = window.localStorage.getItem('CBX_Step_Ticket');
  return currentStep ? parseInt(currentStep, 10) : 1;

}

export function setCurrentStepParking(stepParking) {
  window.localStorage.setItem('CBX_Step_Parking', stepParking.toString(10));
}

export function getCurrentStepParking() {
  const currentStep = window.localStorage.getItem('CBX_Step_Parking');
  return currentStep ? parseInt(currentStep, 10) : 1;
}

